import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { axiosErrorHandler, axiosGetWithHeader, axiosPostWithHeader, ShowAlertError } from '../Common/axios';
import Title, { Message, SubmitClearButton } from '../Login/LoginUtil';
import { validateCity, validateDouble, validateEmail, validateFatherName, validateMobile, validateName } from './ClientValidate';
import { Input, Date, DateTime, Email, FirstNameLastName, LocationCoordinates, MaritalStatus, Mobile, Sex, Timezone } from './ClientUtil';
import { AppHeader } from '../App/AppHeader';
import { AppFooter } from '../App/AppFooter';
import { Captcha } from '../Common/Captcha';

export function NewClient (props) {
  const [message, setMessage] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [fatherName, setFatherName] = useState('');
  const [sex, setSex] = useState('Male');
  const [birthDate, setBirthDate] = useState('');
  const [birthTime, setBirthTime] = useState('');
  const [birthTimezone, setBirthTimezone] = useState('5.5');
  const [birthCity, setBirthCity] = useState('');
  const [birthLongitude, setBirthLongitude] = useState('');
  const [birthLatitude, setBirthLatitude] = useState('');
  const [maritalStatus, setMaritalStatus] = useState('');
  const [marriageDate, setMarriageDate] = useState('');
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [errorAlert, setErrorAlert] = useState(null);

  const setMethod = { 
    setFirstName, setLastName, setFatherName, setSex, setBirthDate, setBirthTime, setBirthTimezone, setBirthCity,
    setBirthLongitude, setBirthLatitude, setMaritalStatus, setMarriageDate, setEmail, setMobile, setCaptcha, setMessage };

  const firstNameReference = useRef();
  const lastNameReference = useRef();
  const fatherNameReference = useRef();
  const birthDateReference = useRef();
  const birthTimeReference = useRef();
  const marriageDateReference = useRef();
  const birthCityReference = useRef();
  const birthLongitudeReference = useRef();
  const birthLatitudeReference = useRef();
  const mobileReference = useRef();
  const emailReference = useRef();
  const captchaReference = useRef();

  const navigate = useNavigate();

  const handleBack = (event) => {
    setTimeout(() => {
      navigate('/home.html', { replace: true });
    }, 100);
  }

  const handleInput = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    handleLocationInput(name, value);
  }

  const handleLocationInput = (name, value) => {
    switch(name) {
      case 'firstName': setFirstName(value); break;
      case 'lastName': setLastName(value); break;
      case 'fatherName': setFatherName(value); break;
      case 'sex': setSex(value); break;
      case 'birthDate': setBirthDate(value); break;
      case 'birthTime': setBirthTime(value); break;
      case 'birthTimezone': setBirthTimezone(value); break;
      case 'birthCity': setBirthCity(value); break;
      case 'birthLongitude': setBirthLongitude(value); break;
      case 'birthLatitude': setBirthLatitude(value); break;
      case 'maritalStatus': setMaritalStatus(value); break;
      case 'marriageDate': setMarriageDate(value); break;
      case 'email': setEmail(value); break;
      case 'mobile': setMobile(value); break;
      case 'message': setMessage(value); break;
      default : 
    }
  }

  const handleReset = (event) =>{
    const value="";
    setFirstName(value);
    setLastName(value);
    setFatherName(value);
    setSex(value);
    setBirthDate(value);
    setBirthTime(value);
    setBirthTimezone('5.5');
    setBirthCity(value);
    setBirthLongitude(value);
    setBirthLatitude(value);
    setMaritalStatus('');
    setMarriageDate(value);
    setEmail(value);
    setMobile(value);
    setMessage(value);
    setCaptcha(value);
    firstNameReference.current.focus();
  }  

  function setCaptcha(value){
    captchaReference.current?.clearCaptcha(value);
}

  const handleSubmit =  (event) => {
    var msg = '';
    if(msg==='') msg = validateName(event, firstNameReference,firstName,lastNameReference, lastName);
    if(msg==='' && fatherName!==null && fatherName!=="") msg = validateFatherName(event,fatherNameReference,fatherName);
    if(msg==='' && mobile!==null && mobile!=="") msg = validateMobile(event,mobileReference,mobile);
    if(msg==='' && email!==null && email!=="") msg = validateEmail(event,emailReference,email);
    if(msg==='' && birthDate==="" ) {
        msg="Enter birth date";
        birthDateReference.current.focus();
    }
    if(msg==='' && birthTime==="" ) {
      msg="Enter birth time";
      birthTimeReference.current.focus();
    }
    if(msg==='') msg = validateCity(event,"birth place name",birthCityReference,birthCity);
    if(msg==='') msg = validateDouble(event,"latitude",birthLatitudeReference,birthLatitude,-90,90);
    if(msg==='') msg = validateDouble(event,"longitude",birthLongitudeReference,birthLongitude,-180,180);
    //if(msg==='') msg = captchaReference.current?.validateCaptcha();
    setMessage(msg); 
    
    if(msg==='') {
      const data = {
        mobile: mobile,
        email: email,
        firstName: firstName,
        lastName: lastName,
        fatherName: fatherName,
        sex: sex,
        birthDate: birthDate,
        birthTime: birthTime+(birthTime.length===5?":00":""),
        birthTimezone: birthTimezone,
        birthCity: birthCity,
        birthLongitude: birthLongitude,
        birthLatitude: birthLatitude,
        maritalStatus: maritalStatus,
        marriageDate: marriageDate
      }
      axiosPostWithHeader("/user/add", data,
        (response)=>{
          if(response.data.code==='200') {
              axiosGetWithHeader("/users/history/"+response.data.runningId, 
                (response)=>{
                  console.log(response.message);
                },
                (error)=>{
                  console.log(error);
                }
              );
              setTimeout(() => {
                  navigate('/kpastro.html', { state:{runningId:response.data.runningId}, replace: true });
                  navigate(0);
              }, 100);
          }
        },
        (error)=>{
          setMessage(axiosErrorHandler(firstNameReference,error));
          setErrorAlert(error.message);
        }
      );
    }
    event.preventDefault();
  }

  return(
    <>
        <div class="m-0 p-0 row sticky-top bg-white noprint">
            <div class="m-0 p-0 col-sm-12 col-md-12">
                <AppHeader/>
            </div>    
        </div> 

    <div class="row align-items-top m-0 homepageheight overflow-auto">
      <div class="col-sm-2 col-md-2 d-none d-md-block"></div>    
      
      <div class="col-sm-12 col-md-8 m-0 p-2 bg-white text-black">
        <Title title="Add Client" urlcallback={handleBack}></Title>
        <div class="row m-0 p-0 w-100 border rounded">
        <div class="col m-0 p-0 justify-content-center">

          <Message msg={message} />
          <form method="post" onSubmit={handleSubmit}>
              <div class="row m-0 p-0 w-100">
              <div class="col-sm-12 col-lg-6">
                <FirstNameLastName title="Name * " firstnamereference={firstNameReference} lastnamereference={lastNameReference} firstvalue={firstName} lastvalue={lastName} callback={(event)=>handleInput(event,setMethod)} />
                <Input name="fatherName" title="Father Name" placeholder="Father Name (optional)" reference={fatherNameReference} data={fatherName} callback={(event)=>handleInput(event,setMethod)} />
                <Mobile reference={mobileReference} data={mobile} callback={(event)=>handleInput(event,setMethod)} optional="true"/>
                <Email reference={emailReference} data={email} callback={(event)=>handleInput(event,setMethod)} optional="true"/>
                <MaritalStatus name="maritalStatus" title="Marital Status" data={maritalStatus} callback={(event)=>handleInput(event,setMethod)} />
                <Date name="marriageDate" title="Marriage Date" reference={marriageDateReference} data={marriageDate} callback={(event)=>handleInput(event,setMethod)} />
              </div>
              <div class="col-sm-12 col-lg-6">
                <Sex name="sex" title="Sex" data={sex} callback={(event)=>handleInput(event,setMethod)} />
                <Timezone name="birthTimezone" data={birthTimezone} callback={(event)=>handleInput(event,setMethod)} />
                <DateTime title1="Date of Birth * " title2="Time of Birth * " dateplaceholder="Birth Date" timeplaceholder="Birth Time" 
                  datename="birthDate" timename="birthTime" 
                  datereference={birthDateReference} timereference={birthTimeReference} 
                  datevalue={birthDate} timevalue={birthTime} callback={(event)=>handleInput(event,setMethod)} />
                <LocationCoordinates 
                      cityname="birthCity" citytitle="Place of Birth * " cityreference={birthCityReference} cityvalue={birthCity}
                      coordinatesname="location" coordinatestitle="Location (Latitude, Longitude) * "
                      longitudename="birthLongitude" latitudename="birthLatitude" 
                      longitudereference={birthLongitudeReference} latitudereference={birthLatitudeReference} 
                      longitudevalue={birthLongitude} latitudevalue={birthLatitude} 
                      callback={(event)=>handleInput(event,setMethod)}  callbacklocation={handleLocationInput} />
                <Captcha ref={captchaReference}/>
              </div>
            </div>

            <div class="card-body d-flex justify-content-center p-0 ">
              <div class="w-50">
                <SubmitClearButton callback={handleReset} /> 
              </div>
            </div>  
          </form>
              </div>
        </div>
      </div>

      <div class="col-sm-2 col-md-2 d-none d-md-block"></div>    
    </div>

        <div class="m-0 p-0 row noprint">
            <div class="m-0 p-0 col-sm-12 col-md-12">
                <AppFooter/>
                <ShowAlertError errorAlert={errorAlert} setErrorAlert={setErrorAlert}/>
            </div>    
        </div> 

    </>
  );

}
